import { notificationConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";

//schedule interview
export const get_calendar_notification_action = () => async (dispatch) => {
  dispatch({
    type: notificationConstants.GET_CALENDAR_NOTIFICATIONS_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.common.notifications.calendarInviteNotification
    );
    if (response.status) {
      dispatch({
        type: notificationConstants.GET_CALENDAR_NOTIFICATIONS_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: notificationConstants.GET_CALENDAR_NOTIFICATIONS_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};
//schedule interview
export const mark_calendar_notification_read_action =
  (id, data) => async (dispatch) => {
    dispatch({
      type: notificationConstants.MARK_CALENDAR_NOTIFICATIONS_READ_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        `${config.common.notifications.calendarInviteNotification}/${id}`,
        data
      );
      if (response.status) {
        dispatch({
          type: notificationConstants.MARK_CALENDAR_NOTIFICATIONS_READ_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: notificationConstants.MARK_CALENDAR_NOTIFICATIONS_READ_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };
//schedule interview
export const get_invited_jobs_notification_action =
  () => async (dispatch) => {
    dispatch({
      type: notificationConstants.GET_INVITED_JOBS_NOTIFICATIONS_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.common.notifications.jobInviteNotifications
      );
      if (response.status) {
        dispatch({
          type: notificationConstants.GET_INVITED_JOBS_NOTIFICATIONS_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: notificationConstants.GET_INVITED_JOBS_NOTIFICATIONS_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//schedule interview
export const mark_invited_jobs_notification_read_action =
  (id, data) => async (dispatch) => {
    dispatch({
      type: notificationConstants.MARK_INVITED_JOBS_NOTIFICATIONS_READ_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        `${config.common.notifications.jobInviteNotifications}/${id}`,
        data
      );
      if (response.status) {
        dispatch({
          type: notificationConstants.MARK_INVITED_JOBS_NOTIFICATIONS_READ_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: notificationConstants.MARK_INVITED_JOBS_NOTIFICATIONS_READ_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };
//schedule interview
export const get_job_changes_notification_action = () => async (dispatch) => {
  dispatch({
    type: notificationConstants.GET_JOB_CHANGES_NOTIFICATIONS_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.common.notifications.jobNotifications
    );
    if (response.status) {
      dispatch({
        type: notificationConstants.GET_JOB_CHANGES_NOTIFICATIONS_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: notificationConstants.GET_JOB_CHANGES_NOTIFICATIONS_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

//schedule interview
export const mark_job_changes_notification_read_action =
  (id, data) => async (dispatch) => {
    dispatch({
      type: notificationConstants.MARK_JOB_CHANGES_NOTIFICATIONS_READ_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        `${config.common.notifications.jobNotifications}${id}/`,
        data
      );
      if (response.status) {
        dispatch({
          type: notificationConstants.MARK_JOB_CHANGES_NOTIFICATIONS_READ_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: notificationConstants.MARK_JOB_CHANGES_NOTIFICATIONS_READ_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };
